module.exports = __webpack_public_path__ + "app-static/img/submit.8b86b65a.png";